import { render, staticRenderFns } from "./AuthHeaderCpt.vue?vue&type=template&id=f495da8e&scoped=true&"
import script from "./AuthHeaderCpt.vue?vue&type=script&lang=ts&"
export * from "./AuthHeaderCpt.vue?vue&type=script&lang=ts&"
import style0 from "./AuthHeaderCpt.vue?vue&type=style&index=0&id=f495da8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f495da8e",
  null
  
)

export default component.exports